import { useMemo, useState } from 'react';
import { useEventReporter, useOverlayContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
export function useResendInvoice() {
    const { api, logBI } = useStoreActions();
    const { t: commonTexts } = useLocaleKeys('common');
    const { showErrorToast, showSuccessToast } = useOverlayContext();
    const { reportToHeap } = useEventReporter();
    const [loading, setLoading] = useState(false);
    return useMemo(()=>{
        return {
            isResendingInvoice: loading,
            async resendInvoice (invoice) {
                logBI(10581);
                reportToHeap('Invoice', 'click', 'resend');
                try {
                    setLoading(true);
                    await api.invoice.resend(invoice.id);
                    showSuccessToast("Email sent ".concat('relationship' in invoice ? "to ".concat(invoice.relationship.customer.name) : 'successfully'));
                } catch (error) {
                    showErrorToast(commonTexts.toasts.failedToSendEmail());
                    throw error;
                } finally{
                    setLoading(false);
                }
            }
        };
    }, [
        loading
    ]);
}
